import axios from 'axios'
import { buildRequestPrerequisites } from './dataService'

export const deleteImage = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites(globalState)

  const { id, category } = params
  const url = `${baseUrl}/images/id/${id}/category/${category}`
  try {
    const { status } = await axios({
      method: 'delete',
      url,
      headers,
      params: {
        api_key: apiKey
      }
    })
    return {
      data: { isDeleted: status === 200 },
      error: null
    }
  } catch (error) {
    return { data: null, error }
  }
}

export const uploadImage = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites(globalState)
  const { formData } = params
  const url = `${baseUrl}/images`
  try {
    const { data, status } = await axios.post(url, formData, {
      headers,
      params: {
        api_key: apiKey
      }
    })
    return {
      data,
      error: null,
      status
    }
  } catch (error) {
    return { data: null, error, status: error.response?.status }
  }
}

export const getImageUploadUrl = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites(globalState)
  const url = `${baseUrl}/images/uploadurl`
  try {
    const response = await axios.get(url, {
      headers,
      params: {
        api_key: apiKey,
        filename: params.filename
      }
    })
    const {
      data: { data },
      status
    } = response
    return {
      data,
      error: null,
      status
    }
  } catch (error) {
    console.log(`getImageUploadUrlError: ${JSON.stringify(error)}`)
    return { data: null, error, status: error.response?.status }
  }
}

export const uploadImageToS3 = async ({ params }) => {
  try {
    const response = await axios.put(params.uploadUrl, params.blobImage, {
      headers: {
        'Content-Type': params.contentType
      }
    })
    const { data, status } = response
    return {
      data,
      error: null,
      status
    }
  } catch (error) {
    console.log(`uploadImageToS3Error: ${JSON.stringify(error)}`)
    return { data: null, error, status: error.response?.status }
  }
}

export const validateImage = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites(globalState)
  const url = `${baseUrl}/images/validation`
  try {
    const response = await axios.get(url, {
      headers,
      params: { ...params, api_key: apiKey }
    })
    const {
      data: { data },
      status
    } = response
    return {
      data,
      error: null,
      status
    }
  } catch (error) {
    console.log(`validateImageError: ${JSON.stringify(error)}`)
    return { data: null, error, status: error.response?.status }
  }
}

export const getImage = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites(globalState)
  const { prospectId } = params
  const url = `${baseUrl}/images/id/${prospectId}`
  try {
    const { data } = await axios.get(url, {
      headers,
      params: {
        api_key: apiKey
      }
    })
    return {
      data,
      error: null
    }
  } catch (error) {
    return { data: null, error }
  }
}
